import { colors, spacing } from "../../../stitches.config";
import { SpinnerContainer, SpinnerRing } from "./__styles__/LoadingSpinner";

export type LoadingSpinnerProps = {
  size?: string;
  color?: string;
};

const LoadingSpinner = ({
  size = spacing.m.value,
  color = colors.grey500.value,
}: LoadingSpinnerProps) => {
  return (
    <SpinnerContainer
      role="status"
      aria-live="polite"
      aria-label="Loading"
      css={{ width: size, height: size }}
      data-testid="assistant-loading-spinner"
    >
      <SpinnerRing
        css={{ borderColor: `${color}20 ${color}20 ${color}20 ${color}` }}
      />
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
